import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DialogContainerComponent } from './core/dynamic-dialog/dialog-container.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    DialogContainerComponent,
  ],
  templateUrl: './app.html',
})
export class App {
}
